import stateGlob from './state';
import { useState } from 'react';
import './index.css';
const albumData = stateGlob.albumData;


//displays the album name and artist
const Header = () => {
    const data = albumData.at(stateGlob.state - 1);
    const name = data.name;
	const artist = data.artist;
    return(
        <div className="header">
            {name} - {artist}
        </div>
    )
}

//displays what song is playing, auto play and play/pause functions
const Player = (props) => {
    //props contains the updateSettings function, which allows the play/loop images to update when clicked
    return(
        <div className="player">
            <img src = {require(`./icons/back.png`)} alt = ":(" height = '30%' id = "back" onClick = {props.skip}/>&nbsp;<img src = {require(`./icons/play-${stateGlob.playing}.png`)} className="icons" alt = ":(" height = '30%' id = "playIcon" onClick = {props.function}/> &nbsp;&lt; {stateGlob.song} - {stateGlob.artist} &gt; <img src = {require(`./icons/autoplay-${stateGlob.looping}.png`)} alt = ":(" height = '30%' id = "loopIcon" onClick = {props.function}/>&nbsp;<img src = {require(`./icons/forward.png`)} alt = ":(" height = '30%' id = "forward" onClick = {props.skip}/>
        </div>
    )
}

//https://stackoverflow.com/questions/38364400/index-inside-map-function for index
//returns all of the songs in the list as table rows
const AlbumSongs = (props) => {
    const data = albumData.at(props.album - 1);
    const songsArray = data.songs.split("@@");
    //this is for whether or not playing.gif is shown, to indicate which song is playing
    const playingIcon = [];
    for(let i = 0; i < songsArray.length; i++) {
        if(songsArray[i] === stateGlob.song){
            const img = <img src = {require(`./icons/playing.gif`)} alt = ":(" style = {{display: "inline"}}/>;
            playingIcon.push(img);
        } else {
            const img = <img src = {require(`./icons/playing.gif`)} alt = ":(" style = {{display: "none"}}/>;
            playingIcon.push(img);
        }  
    }
    return(
        <tbody>
            {songsArray.map((song, i) => <tr id = {song} onClick={props.function} key = {i}><td>{i+1} - {song} &nbsp; {playingIcon[i]}</td></tr>)}
        </tbody>
    )
}

const App = () => {
    //only used to update display when needed
    const [ update, callUpdate ] = useState(0);

    //gets the next song in the array, will only be called if *not* the last song
    const nextSong = () => {
        const songs = stateGlob.albumData[stateGlob.state - 1].songs;
        const indexOf = songs.split("@@").indexOf(stateGlob.song);
        if(songs.split("@@").length <= indexOf + 1) return -1;
        return(songs.split("@@")[indexOf + 1]);
    }
    //same as above
    const prevSong = () => {
        const songs = stateGlob.albumData[stateGlob.state - 1].songs;
        const indexOf = songs.split("@@").indexOf(stateGlob.song);
        if(indexOf - 1 <= -1) return -1;
        return(songs.split("@@")[indexOf - 1]);
    }

    //used when clicking the images in the player div 
    const updateSettings = event => {
        if(event.target.id === "playIcon") {
            if(stateGlob.song !== "no song playing"){
                stateGlob.playing = !stateGlob.playing;
            }
        } else if(event.target.id === "loopIcon") {
            stateGlob.looping = !stateGlob.looping;
        } else {
            console.log("OH NO");
        }
        //audio controls
        if(!stateGlob.playing) {
            stateGlob.audio.pause();
        } else if(stateGlob.playing) {
            stateGlob.audio.play();
        }
        callUpdate(update + 1);
    }
    //plays the song!
    const playSong = event => {
        //if the song is played because of a click, then this will work
        try {
            stateGlob.song = event.currentTarget.id;
        }
        //otherwise, it's an error, playing a song (still) because looping is true
        catch(err) {
            console.log("from loop");
        }
        stateGlob.playing = true;
        const album = stateGlob.albumData[stateGlob.state - 1].name;
        stateGlob.artist = stateGlob.albumData[stateGlob.state - 1].artist;
        const toPlay = require(`./songs/${album}/${stateGlob.song}.mp3`);
        //pause the current song so it doesn't keep playing
        if(stateGlob.audio != null) {
            stateGlob.audio.pause();
        }
        //reset it, and play it
        stateGlob.audio = new Audio(toPlay);
        stateGlob.audio.play();
        callUpdate(update + 1);
    }

    //skips the song, goes to either the one before or one after
    const skipSong = event => {
        //id from the images that have this as their onClick function
        if(event.currentTarget.id === "back") {
            try {
                stateGlob.song = prevSong();
                playSong();
            } catch(err) {
                stateGlob.audio.pause();
                stateGlob.song = "no song playing";
                stateGlob.artist = "no current artist";
                stateGlob.playing = false;
            }
        } else if(event.currentTarget.id === "forward") {
            try {
                stateGlob.song = nextSong();
                playSong();
            } catch(err) {
                stateGlob.audio.pause();
                stateGlob.song = "no song playing";
                stateGlob.artist = "no current artist";
                stateGlob.playing = false;
            }
        } else {
            //this should never show
            console.log("????");
        }
        callUpdate(update + 1);
    }

    //when the current song playing ends
    stateGlob.audio.onended = (event) => {
        if(stateGlob.looping === true) {
            //will try to send to next song, if there's one after
            try{
                stateGlob.song = nextSong();
                playSong();
            //otherwise it catches the error and sets it to no song playing
            } catch(err) {
                stateGlob.song = "no song playing";
                stateGlob.artist = "no current artist";
                stateGlob.playing = false;
            }
        //if not looping, sets it to no song playing
        } else {
            stateGlob.song = "no song playing";
            stateGlob.artist = "no current artist";
            stateGlob.playing = false;
        }
        callUpdate(update + 1);
    }
    return (
        <div className="container">
            <Header/>
            <Player function = {updateSettings} skip = {skipSong}/>
            <table className = "table">
                <AlbumSongs album = {stateGlob.state} function = {playSong}/> 
            </table>
		</div>
    )
}

export default App
